import { useState, useEffect } from "react"

import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'

import EscolaService from '@services/EscolaService'
import SelectOption from '@base/Inputs/Select'
import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"
import TextField from '@base/Inputs/Text'

export const DescartarCartaoDialog = (props) => {
  const processo = props.processo;

 const [listagemMotivos, ] = useState(props.motivosDescarteDisponiveis);
  const [formTratamentoEscola, setFormTratamentoEscola] = useState("");
  const [, setFormTratamentoCartaoId] = useState("");
  const [formTratamentoCartao, setFormTratamentoCartao] = useState("");
  const [formTratamentoNome, setFormTratamentoNome] = useState("");
 const [formTratamentoCartaoMotivo, setFormTratamentoCartaoMotivo] = useState("");
 const[loading,setLoading] = useState(false);

  const buttonsSubmit = () => <ButtonSave name="Confirmar" onClick={descartar} loading={loading} />

  const descartar = () => {

    setLoading(true);
   let obj = {};
	obj.motivo = formTratamentoCartaoMotivo;

    EscolaService.descartarCartao(props.processo, props.id, obj).then(resultado => {
      props.aoConfirmar(resultado);
      props.aoFechar();
      setLoading(false);
    });

  }

  useEffect(() => {
    if (props.id) {
      EscolaService.buscaDadosDoCartao(processo, props.id).then(pendencia => {
        setFormTratamentoEscola(pendencia.data.escola);
        setFormTratamentoCartao(pendencia.data.codigo);
        setFormTratamentoCartaoId(pendencia.data.id);
        setFormTratamentoNome(pendencia.data.nomeAluno);
      });
    }

  }, [props.id, processo]);

  return (
    <Dialog
      maxWidth={"md"}
      fullWidth={true}
      closeDialog={props.aoFechar}
      openDialog={props.aberto}
      title="Descartar Cartão"
      actions={buttonsSubmit()}
    >

      <Alert severity="warning">O descarte deste cartão poderá ser desfeito caso necessário.</Alert>

      {props.mensagemCustomizada ?
        <Alert severity="warning">{props.mensagemCustomizada}</Alert> : ""}

      <Grid container spacing={3}>
        <Grid item sm={8}>
          <TextField disabled label="Escola" value={formTratamentoEscola} />
        </Grid>

        <Grid item sm={4}>
          <TextField disabled label="Código do Cartão" value={formTratamentoCartao} />
        </Grid>

      </Grid>

      {formTratamentoNome &&
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <TextField disabled label="Nome do Aluno" value={formTratamentoNome} />
          </Grid>
        </Grid>
      }
		<Grid container spacing={3}>
        <Grid item sm={8}>
          <SelectOption
				label='Motivo'
				value={formTratamentoCartaoMotivo}
				name='formTratamentoCartaoMotivo'
				onChange={(e) => setFormTratamentoCartaoMotivo(e.target.value)}
				options={listagemMotivos}
			/>
        </Grid>



      </Grid>

    </Dialog>
  );
}

export default DescartarCartaoDialog;
